import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AuthAmplifyService } from 'src/app/shared/service/auth-amplify.service';
import { Auth } from "aws-amplify";
import { Router } from '@angular/router';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthenticateComponent implements OnInit {

  auth = Auth;
  isLoggedInUser = false;
  loggedInUserData: any;

  private readonly authService = inject(AuthAmplifyService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    localStorage.clear();
    this.proxyLogin();
  }

  proxyLogin() {
    this.authService.proxyLogin().subscribe(response => {
      this.navigate(response.data);
      localStorage.setItem('loggedIn', 'true')
    });
  }

  navigate(url: string) {
    window.location.assign(url);
  }

  login() {
    this.authService.signIn();
  }

}